var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lang_chart"},[_c('Chart',{attrs:{"chartData":_vm.chartData,"chartOptions":_vm.chartOptions,"chartType":_vm.chartType,"id":_vm.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }